import React from "react";
import { Box, Chip, Tooltip, Typography } from "@material-ui/core";
import styled from "styled-components/macro";

const ChipsWrap = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;

const ParameterChips = ({ parameters, selected, onSelect, caption }) => {
  if (!parameters?.length) return null;

  return (
    <Box>
      <Typography variant="subtitle2">Active Parameter</Typography>
      <Typography
        variant="caption"
        color="textSecondary"
        display="block"
        style={{ marginBottom: 6 }}
      >
        Selecting a parameter narrows the map to wells that recorded it, labels
        each visible well with its most recent result, and pre-selects that
        parameter's tab in the popup. Click a chip again to clear.
      </Typography>
      <ChipsWrap>
        {parameters.map((p) => {
          const isSelected = selected === p.aqsci_parameter_ndx;
          return (
            <Tooltip
              key={p.aqsci_parameter_ndx}
              title={p.parameter_name || ""}
              arrow
              placement="top"
            >
              <Chip
                label={p.parameter_abbrev || p.parameter_name}
                clickable
                color={isSelected ? "primary" : "default"}
                variant={isSelected ? "default" : "outlined"}
                onClick={() =>
                  onSelect(isSelected ? null : p.aqsci_parameter_ndx)
                }
              />
            </Tooltip>
          );
        })}
      </ChipsWrap>
      {caption && (
        <Typography
          variant="caption"
          color="textSecondary"
          display="block"
          style={{ marginTop: 6 }}
        >
          {caption}
        </Typography>
      )}
    </Box>
  );
};

export default ParameterChips;
